import React from "react";
import { RaisedButton } from "material-ui";
import uniqueId from "lodash/uniqueId";

import SupplementaryDataEditorField from "./supplementary-data-editor-field.jsx";
import InfoNotice from "./info-notice.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PassBucketActions from "../../actions/PassBucketActions";
import PassBucketStore from "../../stores/PassBucketStore";

class SupplementaryDataEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetchingFields: false,
      isEdited: false,
      lastUpdatedAt: null,
      invalidFieldTexts: [],
      fields: [],
    };

    this.addField = this.addField.bind(this);
    this.save = this.save.bind(this);
  }

  static getStores() {
    return [PassBucketStore];
  }

  static getPropsFromStores() {
    return {
      getPassBucketById: PassBucketStore.getPassBucketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      actions: {
        marginTop: 10
      }
    };
  }

  save() {
    let fields = this.state.fields.map(f => Object.assign({}, f));
    fields.forEach(f => {
      delete f._temp_id;
    });
    PassBucketActions.edit(this.props.passBucketId, {
      supplementary_data: fields
    });
  }

  addField() {
    let fields = this.state.fields;
    fields.push({
      type: "string",
      key: `data_${Date.now()}`,
      _temp_id: uniqueId("supplementarydatafield_")
    });
    this.validateFields(fields);
    this.setState({ fields });
  }

  updateField(index, field) {
    let fields = this.state.fields;

    if (field === null) {
      // delete rule
      fields.splice(index, 1);
    } else {
      fields[index] = field;
    }

    this.validateFields(fields)

    this.setState({ fields, isEdited: true });
    if (this.props.onEdited) {
      this.props.onEdited(field);
    }
  }

  validateField(field, index = 0) {
    let invalidText = ""

    const currentIndex = index + 1

    if (field.type === 'select') {
      invalidText = typeof field.options !== "undefined" && field.options.length > 0 ? "" : `You have an invalid field! Field #${currentIndex} does not have any options! Please add an option to the field.`
    }

    if (field.type === "checkbox") {
      invalidText = typeof field.checkbox_label !== "undefined" && field.checkbox_label !== "" ? "" : `You have an invalid field! Field #${currentIndex} does not have a checkbox label! Please add the checkbox label to the field.`
    }

    return typeof field.label === "undefined" || field.label === "" ? `You have an invalid field! Field #${currentIndex} has a blank label. Make sure all fields have labels.` : invalidText;
  }

  validateFields(fields) {
    const { requiredFieldsToPurchase } = this.props;

    const invalidFieldTexts = []

    fields.forEach((field, i) => {
      const invalidText = this.validateField(field, i);
      if (invalidText !== "") {
        invalidFieldTexts.push(invalidText);
      }
    })

    if (requiredFieldsToPurchase && fields.length <= 0) {
      invalidFieldTexts.push("There needs to be at least 1 field present while supplementary data is required before purchase. Please change the setting in the Messages tab if you do not want supplementary fields anymore.")
    }

    this.setState({ invalidFieldTexts })
  }

  shiftPosition(index, direction) {
    let fields = this.state.fields;
    fields.splice(index + direction, 0, fields.splice(index, 1)[0]);
    this.setState({ fields, isEdited: true });
    this.validateFields(fields);
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var passBucket = PassBucketStore.getPassBucketById(newProps.passBucketId),
      fields = passBucket ? passBucket.supplementary_data || [] : null;

    if (!fields && !this.state.isFetchingFields) {
      PassBucketActions.fetchOne(newProps.passBucketId);
      this.setState({ isFetchingFields: true, fields: [] });
    } else if (fields && this.state.lastUpdatedAt !== passBucket.updated_at) {
      fields.forEach(f => {
        f._temp_id = uniqueId("supplementarydatafield_");
      });
      this.setState({
        isFetchingFields: false,
        fields: fields,
        isEdited: false,
        lastUpdatedAt: passBucket.updated_at
      });
    }
  }

  render() {
    let styles = this.getStyles();
    let isMembership = this.props.isMembership;

    let fieldComponents = this.state.fields.map((f, i) => {
      return (
        <SupplementaryDataEditorField
          key={`field-${f._temp_id}`}
          field={f}
          shiftPosition={this.shiftPosition.bind(this, i)}
          canShiftUp={i > 0}
          canShiftDown={i < this.state.fields.length - 1}
          update={this.updateField.bind(this, i)}
          index={i + 1}
        />
      );
    });

    return (
      <div>
        {this.props.showHeader ? <h2>Supplementary data</h2> : null}
        <p>
          {`Use these fields to collect more than just a name from ${isMembership ? "members" : "passholders"}.`}
          <InfoNotice style={{ marginTop: 5 }}>
            Check out our{" "}
            <a
              href="http://help.eventive.org/passes/collect-supplementary-data"
              target="_blank"
            >
              guide to collecting supplementary data
            </a>
            .
          </InfoNotice>
        </p>
        {fieldComponents}
        <ul>
          {this.state.invalidFieldTexts.length > 0 && this.state.invalidFieldTexts.map(text => (
            <li style={{ color: "red" }}>
              {text}
            </li>
          ))}
        </ul>

        <div style={styles.actions}>
          <RaisedButton
            label="Save fields"
            onTouchTap={this.save}
            primary={true}
            disabled={!this.state.isEdited || this.state.invalidFieldTexts.length > 0}
            style={{ marginRight: 7 }}
          />
          <RaisedButton label="Add new field" onTouchTap={this.addField} />
        </div>
      </div>
    );
  }
}

export default connectToStores(SupplementaryDataEditor);



// WEBPACK FOOTER //
// ./src/app/components/partials/supplementary-data-editor.jsx